export default {
  SET_SURVEY(state, survey) {
    state.survey = survey;
  },
  ADD_ACMLT_SURVEY_ANS_ITM_ID(state, surveyAnsItmId) {
    surveyAnsItmId.forEach((ansItmId) => {
      state.acmltSurveyAnsItmId.push(ansItmId);
    });
  },

  SET_BEFORE_SURVEY_STATE(state) {
    state.beforeSurveyState.push({
      survey: state.survey,
      acmltSurveyAnsItmId: [...state.acmltSurveyAnsItmId],
    });
  },
  ROLLBACK_BEFORE_SURVEY_STATE(state) {
    const beforeSurveyState =
      state.beforeSurveyState[state.beforeSurveyState.length - 1];

    state.survey = beforeSurveyState.survey;
    state.acmltSurveyAnsItmIdForChecking = state.acmltSurveyAnsItmId; // 현재문제에서 선택했던 보기번호
    state.acmltSurveyAnsItmId = beforeSurveyState.acmltSurveyAnsItmId; // 이전문제까지 선택했던 보기번호

    state.beforeSurveyState = state.beforeSurveyState.slice(0, -1);
  },
};
